<main class="w-full bg-white shadow-sm">
  <!-- grid component -->
  <app-dynamic-grid
    [gridConfig]="gridConfig"
    [getDataUrl]="getDataUrl"
    [toggleUrl]="toggleUrl"
    [sortBy]="'practiceName'"
    [sortOrder]="'desc'"
    (addClicked)="onAddHandler()"
    (editClicked)="onEditHandler($event)"
    (onToggleShowToastEmitter)="showToast($event)"
  ></app-dynamic-grid>

  <!-- add/edit operational hours drawer -->
  <app-drawer
    #operationalHoursDrawer
    [drawerModel]="drawerModel"
    [drawerConfig]="drawerInputConfig"
    [AddDataURL]="addDataUrl"
    [editDataURL]="editDataUrl"
    [removeLevel]="false"
    [maxDrawerHeight]="'max-h-[450px]'"
    (refresh)="refreshHandler()"
    [createDrawerTitle]="'Add Practice Operational Hours'"
    [updateDrawerTitle]="'Update Practice Operational Hours'"
    [hasTwoColumns]="false"
    (resetData)="resetEntry()"
  ></app-drawer>
  
  <app-toast></app-toast>
</main>
